import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { StateRequirement } from '../../model/staterequirements.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { configURI, stateRequirmentURL } from '../../../shared/apiUrlConfig';
// import {HttpHeaders} from '@angular/common/http';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class StateRequirementService {
  loginId;
  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
   }

  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  // headers = new Headers({'x-access-token': localStorage.getItem('Token'),'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'});
  // options = new RequestOptions({headers: this.headers});

  getStateRequirmentByStateCode(stateCode: string, vendorId: number): Observable<StateRequirement> {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    const url = `${environment.stateRequirmentURL}/${stateCode}/${vendorId}`;
    const clientURL = `${environment.configURI}/client/StateRequirements/${stateCode}`
    let role = parseInt(localStorage.getItem("RoleVal"))
    if(role === 8){
      return this.httpClient.get(clientURL).catch(this.userFriendlyMsgs.errorHandler);
    }else{
      return this.httpClient.get(url).catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  postStateRequirements(saveStateRequirement: StateRequirement): Observable<any> {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    saveStateRequirement.created_by = this.loginId;
    saveStateRequirement.updated_by = this.loginId;
    const addStateRequirementsURL = `${environment.stateRequirmentURL}`;
    return this.httpClient.post(addStateRequirementsURL, saveStateRequirement).catch(this.userFriendlyMsgs.errorHandler);
  }

  updateStateRequirements(saveStateRequirement: StateRequirement): Observable<any> {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    saveStateRequirement.updated_by = this.loginId;
    //const updateStateRequirementsURL = `${environment.stateRequirmentURL}/${saveStateRequirement.StateCode}`;
    const updateStateRequirementsURL = `${environment.stateRequirmentURL}/${saveStateRequirement.StateCode}/${saveStateRequirement.VendorId}`;
    //const updateStateRequirementsURL = `${stateRequirmentURL}/Update/${saveStateRequirement.StateCode}`;
    return this.httpClient.put(updateStateRequirementsURL, saveStateRequirement).catch(this.userFriendlyMsgs.errorHandler);
  }

  private handleError(error: Response | any) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/state_requirements/staterequirements.service.ts